import axios from '../utils/axios';

export default function updatMultiplePotentialJobs(adminId, data, params) {
    return axios.post(`/admin/${adminId}/update-multiple/potential-paid-job`, data, { params, });
};
